"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// TODO: ACLRequest components in UI lib
var ACLRequestList = function ACLRequestList(_ref) {
  var requests = _ref.requests,
      openRequest = _ref.openRequest,
      _ref$emptyLabel = _ref.emptyLabel,
      emptyLabel = _ref$emptyLabel === void 0 ? 'Nog geen afgeschermde informatie aangevraagd.' : _ref$emptyLabel;

  if (!requests || requests.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      Icon: _Lock["default"],
      label: emptyLabel
    });
  }

  var iconMap = {
    granted: _Check["default"],
    denied: _Close["default"],
    pending: _HelpOutline["default"]
  };
  var labelMap = {
    granted: function granted(d) {
      return "toegekend op ".concat(d);
    },
    denied: function denied(d) {
      return "geweigerd op ".concat(d);
    },
    pending: function pending(d) {
      return "aangevraagd op ".concat(d);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.List, null, requests.map(function (_ref2) {
    var _id = _ref2._id,
        formattedDate = _ref2.formattedDate,
        certificate = _ref2.certificate,
        grants = _ref2.grants;
    var status = grants ? grants.documents ? 'granted' : 'denied' : 'pending';
    var Icon = iconMap[status];
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(Icon, null),
      text: certificate.key,
      textLabel: labelMap[status](formattedDate),
      style: {
        padding: 0
      },
      onClick: function onClick() {
        return openRequest(_id);
      }
    });
  }));
};

ACLRequestList.propTypes = {
  downloads: _propTypes["default"].array
};
var _default = ACLRequestList;
exports["default"] = _default;